<form
  action="."
  #searchInput
  [formGroup]="searchForm"
  class="search-box"
  fxLayout="row nowrap"
  fxLayoutAlign="start center"
  novalidate
>
  <div
    [mmTestState]="'expanded-on-mobile'"
    class="search-box__group"
    fxLayout="row nowrap"
    fxLayoutAlign="space-between center"
    [ngClass]="{ 'search-box__group--active': isSuggestionsListVisible$ | async }"
  >
    <div *ngIf="!searchBarFocused" class="search-box__glass-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.086 15.7755L21.5303 21.2197C21.8235 21.513 21.8235 21.987 21.5303 22.2803C21.384 22.4265 21.192 22.5 21 22.5C20.808 22.5 20.616 22.4265 20.4697 22.2803L15.0255 16.836C13.5945 18.03 11.7555 18.75 9.75 18.75C5.20125 18.75 1.5 15.0487 1.5 10.5C1.5 5.95125 5.20125 2.25 9.75 2.25C14.2987 2.25 18 5.95125 18 10.5C18 12.5048 17.2793 14.3438 16.086 15.7755ZM9.75 3.75C6.02775 3.75 3 6.7785 3 10.5C3 14.2215 6.02775 17.25 9.75 17.25C13.4722 17.25 16.5 14.2215 16.5 10.5C16.5 6.7785 13.4722 3.75 9.75 3.75Z"
          fill="#99A1AD"
        />
      </svg>
    </div>
    <input
      [mmTestTarget]="'search-box-input'"
      type="search"
      #searchField
      class="search-box__field"
      [placeholder]="'CORE.ALL_PAGES.HEADER_SEARCH.PLACEHOLDER.TEXT' | translate"
      formControlName="searchTerm"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      name="search"
      spellcheck="false"
      enterkeyhint="search"
      [attr.aria-label]="'CATALOG.CATALOG_PAGE.ZERO_RESULT.OUT_OF_SCOPE.DELIVERY_SERVICE_LINK_SEARCH' | translate"
      (keydown)="onKeydown($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
    <!--Search By Photo Icon and Modal-->
    <div (mouseover)="showSearchByPhotoModal($event)" (mouseleave)="hideSearchByPhotoModal($event)">
      <button
        *ngIf="!searchBarFocused"
        (click)="onPhotoSearchClick($event)"
        class="search_by_photo_btn"
      >
        <span class="sr-only">{{ 'CORE.ALL_PAGES.PHOTO_SEARCH.MODAL.TITLE' | translate }}</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" stroke="none">
          <rect
            x="0.75"
            y="2.25"
            width="18.5"
            height="16.5"
            rx="2.25"
            stroke="#0059E4"
            stroke-width="1.5"
            stroke-linejoin="bevel"
          ></rect>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17 3H3C2.17157 3 1.5 3.67157 1.5 4.5V16.5C1.5 17.3284 2.17157 18 3 18H17C17.8284 18 18.5 17.3284 18.5 16.5V4.5C18.5 3.67157 17.8284 3 17 3ZM3 1.5C1.34315 1.5 0 2.84315 0 4.5V16.5C0 18.1569 1.34315 19.5 3 19.5H17C18.6569 19.5 20 18.1569 20 16.5V4.5C20 2.84315 18.6569 1.5 17 1.5H3Z"
            fill="#0059E4"
          ></path>
          <rect x="10" y="0.5" width="6" height="1.5" rx="0.75" fill="#0059E4"></rect>
          <circle cx="10" cy="10.5" r="4.25" stroke="#0059E4" stroke-width="1.5"></circle>
        </svg>
      </button>
      <div class="search_by_photo_modal" [ngClass]="{ visible: isShowByPictureModalVisible && !searchBarFocused }">
        <div class="search-photo-modal-arrow"></div>
        <div class="search_by_photo_modal_header">
          <p class="search_by_photo_modal_title">
            {{ 'CORE.ALL_PAGES.PHOTO_SEARCH.MODAL.TITLE' | translate }}
            <app-new-badge></app-new-badge>
          </p>
          <button
            class="search-photo-modal-close-btn"
            aria-label="Close button"
            (click)="hideSearchByPhotoModal($event)"
          >
            <svg
              width="16px"
              height="16px"
              class="cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 32 32"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                fill="#667284"
                stroke="none"
                d="M17.885 16l9.724-9.724a1.332 1.332 0 0 0 0-1.885 1.332 1.332 0 0 0-1.885 0L16 14.115 6.276 4.39a1.332 1.332 0 0 0-1.885 0 1.332 1.332 0 0 0 0 1.885L14.115 16 4.39 25.724A1.332 1.332 0 0 0 5.334 28c.341 0 .682-.13.942-.39L16 17.884l9.724 9.724a1.33 1.33 0 0 0 1.885 0 1.332 1.332 0 0 0 0-1.885L17.885 16z"
              ></path>
            </svg>
          </button>
        </div>
        <div>
          <p class="search_by_photo_modal_description">
            {{ 'CORE.ALL_PAGES.PHOTO_SEARCH.MODAL.DESCRIPTION' | translate }}
          </p>
        </div>
        <div class="file-upload-button-wrapper">
          <svg
            width="32px"
            height="32px"
            class="mr-2"
            fill="#99A1AD"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path
              width="32"
              height="32"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.5 9C11.327 9 12 9.673 12 10.5C12 11.327 11.327 12 10.5 12C9.673 12 9 11.327 9 10.5C9 9.673 9.673 9 10.5 9ZM10.5 14C12.43 14 14 12.43 14 10.5C14 8.57 12.43 7 10.5 7C8.57 7 7 8.57 7 10.5C7 12.43 8.57 14 10.5 14ZM25.876 27H6.26L12.89 18.354L15.943 20.402C16.398 20.708 17.013 20.589 17.324 20.138L20.207 15.947L25.876 27ZM6 5H26C26.552 5 27 5.449 27 6V24.809L21.223 13.543C21.063 13.23 20.749 13.025 20.397 13.002C20.047 12.977 19.708 13.144 19.509 13.433L16.236 18.19L13.224 16.169C12.786 15.875 12.193 15.974 11.873 16.392L5 25.356V6C5 5.449 5.448 5 6 5ZM26 3H6C4.346 3 3 4.346 3 6V26C3 27.654 4.346 29 6 29H26C27.654 29 29 27.654 29 26V6C29 4.346 27.654 3 26 3Z"
              fill="#002D72"
              stroke="none"
            ></path>
          </svg>
          <input
            #searchByPhotoInput
            id="search-file-input"
            type="file"
            accept=".jpg,.jpeg,.png,.webp.webp,android/force-camera-workaround"
            class="search-photo-modal-file-input"
            (change)="handlePhotoSearch($event)"
          />
          <label for="search-file-input" class="file-upload-button">
            {{ 'CORE.ALL_PAGES.PHOTO_SEARCH.MODAL.CTA' | translate }}
          </label>
        </div>
      </div>
    </div>
    <!------------------------------------>
    <mm-icon
      *ngIf="showClearIcon && !!searchTerm"
      class="search-box__clear__icon"
      name="close"
      (click)="clearSearch($event)"
    >
    </mm-icon>
    <div *ngIf="searchBarFocused" class="search-box__submit" [ngClass]="{ searchIconBlueBG: searchBarFocused }">
      <app-svg-search
        fxFlex
        (click)="onSubmit()"
        class="search-box__submit__icon"
        [ngClass]="{ searchIconWhite: searchBarFocused }"
      ></app-svg-search>
    </div>
  </div>
</form>
